// extracted by mini-css-extract-plugin
export default {"PaginationV3":"PaginationV3_PaginationV3__F7R+r"};